import React, { useState } from 'react';

import DataBlock from '../data-block/DataBlock';
import FilterSection from '../filter-section/FilterSection';
import AudienceCorrelation from './components/audience-correlation/AudienceCorrelation';
import AudienceCorrelationFilters from './components/audience-correlation-filters/AudienceCorrelationFilters';

import scss from './BackgroundData.module.scss';

function BackgroundData() {
  const [selectedAudience, setSelectedAudience] = useState(null);

  return (
    <div className={scss.pageWrapper}>
      <DataBlock />

      <FilterSection
        filters={({ selectedFilters, onApply }) => (
          <AudienceCorrelationFilters
            selectedFilters={selectedFilters}
            onApply={onApply}
            selectedAudience={selectedAudience}
          />
        )}>
        {({ appliedFilters, onApply }) => (
          <AudienceCorrelation
            appliedFilters={appliedFilters}
            selectedAudience={selectedAudience}
            onSelectAudience={setSelectedAudience}
            onApplyFilters={onApply}
          />
        )}
      </FilterSection>
    </div>
  );
}

export default BackgroundData;
